import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API = process.env.REACT_APP_API_URL || 'https://api-marketing.centraomateriais.com';

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mkt_token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get(`${API}/auth/me`)
        .then(res => setUser(res.data))
        .catch(() => { localStorage.removeItem('mkt_token'); delete axios.defaults.headers.common['Authorization']; })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, senha) => {
    const res = await axios.post(`${API}/auth/login`, { username, senha });
    const { token, user } = res.data;
    localStorage.setItem('mkt_token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('mkt_token');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  const temPermissao = useCallback((chave) => {
    return user?.permissoes?.includes(chave) || false;
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, temPermissao }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
export { API };

